export default "__VITE_ASSET__CwWEz9OY__"